import React, { use, useCallback, useEffect, useRef, useState } from "react";
import { Box, Container, Chip, Stack, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import CreatePost from "./CreatePost";
import OpenCreatePostCard from "./CeateMainPostCard";
import {
  candidate_api_detail_fetch,
  client_detail_api,
  get_feeds_list,
} from "../../DAL/partner/partners";
import PageLoading from "../../components/loader/PageLoading";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import PostCard from "../../components/cards/PostCard";
import { useIds } from "../../hook/AdminContext";
import { useLocation } from "react-router-dom";
import FeedSkeletonLoader from "../../components/loader/Feedskeltonloader";

const categories = ["All", "Resources", "Announcement", "News", "General Feed"];

function MainPart({
  userInfo,
  previewLink,
  setPreviewLink,
  setUrlLink,
  urlLink,
}) {
  const { findId } = useIds();
  const { enqueueSnackbar } = useSnackbar();
  const [pageNumber, setPageNumber] = useState(0);
  const [totlePages, setTotlePages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [feedsList, setFeedsList] = useState([]);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingSection, setIsLoadingSection] = useState(false);
  const [feedType, setFeedType] = useState("general");
  const [formAction, setFormAction] = useState("ADD");
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [selectedFeed, setSelectedFeed] = useState({});
  const [conditionMetOnce, setConditionMetOnce] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const { pathname } = useLocation();
  const firstSegment = pathname.split("/")[1];
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [detailData, setDetailData] = useState(null);

  const [loadMore, setLoadMore] = useState("api/feed/list?page=0&limit=50");

  const observer = useRef();

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totlePages > pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totlePages, pageNumber, loadMorePath, observer]
  );

  const handleSelectedImage = (post, index) => {
    setSelectedIndex(index);
  };

  const handleOpenImageBox = () => {
    setFormAction("ADD");
    setFeedType("image");
    setOpenCreateModal(true);
  };

  const handleOpenVideoBox = () => {
    setFormAction("ADD");
    setFeedType("video");
    setOpenCreateModal(true);
  };

  const typeValue = {
    Resources: "resources",
    News: "news",
    Announcement: "annoucement",
    "General Feed": "general",
    All: "",
  };

  const getFeedsListing = async (value, path_type) => {
    if (!conditionMetOnce || path_type) {
      setIsLoadingSection(true);
    }

    const type = typeValue[value] || "";
    let id = "";
    if (firstSegment !== "home") {
      id = findId || localStorage.getItem("source_id");
    }
    const result = await get_feeds_list(loadMore, id, type);
    if (result.code === 200) {
      setConditionMetOnce(true);
      if (path_type) {
        setFeedsList(result?.data?.feeds);
      } else {
        let newArray = feedsList.concat(result?.data?.feeds);
        setFeedsList(newArray);
      }
      setPageNumber(pageNumber + 1);
      setTotlePages(result?.data?.total_pages);
      setLoadMorePath(result?.data?.load_more);
      setIsLoadingMore(false);
      setIsLoadingSection(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoadingSection(false);
      setIsLoadingMore(false);
    }
  };
  const user_info = JSON.parse(localStorage.getItem("user")) || null;

  const getFeedsListingOnAddFeed = async (path) => {
    setIsLoadingSection(true);
    const type = typeValue[selectedCategory] || "";
    let id = "";
    if (firstSegment !== "home") {
      id = findId || localStorage.getItem("source_id");
    }
    const result = await get_feeds_list(path, id, type);
    if (result.code === 200) {
      setFeedsList(result?.data?.feeds);
      setPageNumber(0);
      setTotlePages(result?.data?.total_pages);
      setLoadMorePath(result?.data?.load_more);
      setIsLoadingMore(false);
      setIsLoadingSection(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoadingMore(false);
      setIsLoadingSection(false);
    }
  };

  // useEffect(() => {
  //   fetchAdminDetails();
  // }, []);

  const getFeedsListingOnDelete = async (id) => {
    const data = feedsList.filter((feed) => feed._id !== id);
    setFeedsList(data);
  };

  const loadMoreData = () => {
    setLoadMore(loadMorePath);
    setIsLoadingMore(true);
  };

  const handleOpenSimpleBox = () => {
    setFormAction("ADD");
    setFeedType("general");
    setOpenCreateModal(true);
  };
  const handleFeedEdit = (selected_feed) => {
    setFormAction("EDIT");
    setSelectedFeed(selected_feed);
    setOpenCreateModal(true);
  };
  useEffect(() => {
    getFeedsListing(selectedCategory, true);
  }, [selectedCategory, firstSegment]);
  useEffect(() => {
    if (loadMore !== "api/feed/list?page=0&limit=10") {
      getFeedsListing(selectedCategory, false);
    }
  }, [loadMore]);
  const user = localStorage.getItem("user");
  const data = user ? JSON.parse(user) : null;
  return (
    <>
      {userInfo?.type === 2 && (
        <>
          <OpenCreatePostCard
            handleOpenSimpleBox={handleOpenSimpleBox}
            userInfo={userInfo}
            data={data}
            handleOpenImageBox={handleOpenImageBox}
            handleOpenVideoBox={handleOpenVideoBox}
            detailData={detailData}
            previewLink={previewLink}
            setPreviewLink={setPreviewLink}
            setUrlLink={setUrlLink}
            urlLink={urlLink}
          />
          <CreatePost
            setFeedType={setFeedType}
            feedType={feedType}
            openCreateModal={openCreateModal}
            setOpenCreateModal={setOpenCreateModal}
            userInfo={userInfo}
            getFeedsListing={getFeedsListingOnAddFeed}
            selectedFeed={selectedFeed}
            type={formAction}
            setFormAction={setFormAction}
            previewLink={previewLink}
            setPreviewLink={setPreviewLink}
            setUrlLink={setUrlLink}
            urlLink={urlLink}
          />
        </>
      )}

      <div className="container-fluid p-0">
        {/* <Stack
          className="stack-overflow"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "20px",
            paddingLeft: "10px",
          }}
          direction="row"
          spacing={1}
          overflow="auto"
        >
          {categories.map((category) => (
            <Chip
              key={category}
              label={category}
              className="pointer"
              onClick={() => {
                setFeedsList([]);
                setSelectedCategory(category);
              }}
              sx={{
                marginTop: "15px !important",
                border: "1px solid #0000002d !important",
                cursor: "pointer",
                backgroundColor:
                  selectedCategory === category
                    ? "#000080 !important"
                    : "inherit !important",
                color:
                  selectedCategory === category ? "#fff !important" : "default",
              }}
            />
          ))}
        </Stack> */}
        {isLoadingSection ? (
          <FeedSkeletonLoader />
        ) : (
          <>
            {feedsList && feedsList.length > 0 ? (
              <Box sx={{ mt: 2, p: 1 }}>
                {feedsList.map((post) => (
                  <PostCard
                    key={post._id}
                    post={post}
                    handleFeedEdit={handleFeedEdit}
                    formAction={formAction}
                    handleSelectedImage={handleSelectedImage}
                    getFeedsListingOnDelete={getFeedsListingOnDelete}
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex}
                    feedsList={feedsList}
                    type={formAction}
                    setUrlLink={setUrlLink}
                    urlLink={urlLink}
                  />
                ))}
              </Box>
            ) : (
              <div className="mt-5">
                <RecordNotFound title="Feed Not" />
              </div>
            )}
          </>
        )}
      </div>

      {!isLoadingSection && totlePages > pageNumber ? (
        <div className="col-12 text-center favourite-buttton-box">
          <div
            ref={lastBookElementRef}
            className="mt-3"
            onClick={loadMoreData}
            id="load-more-feed"
          >
            {isLoadingMore ? (
              <CircularProgress color="navy" size={15} />
            ) : (
              "Load More"
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default MainPart;
